import { render, staticRenderFns } from "./FormPatient.vue?vue&type=template&id=83bd8834&"
import script from "./FormPatient.vue?vue&type=script&lang=js&"
export * from "./FormPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports